import ThemeOverride from '@/components/ThemeOverride';
import { StaticProfileConfig } from '@lemontaps/lib/types/api';
import { Box, Typography, styled } from '@mui/material';

type Props = {
  config: StaticProfileConfig['header']['bioContent'];
  isEdit?: boolean;
  showLeftBorder?: boolean;
};

export default function Bio({ config, isEdit, showLeftBorder }: Props) {
  return (
    <Box display='flex'>
      {showLeftBorder && <DashedVerticalLine />}
      <Wrapper>
        <ThemeOverride
          overrides={{
            typography: {
              h1: {
                marginBottom: '.75rem',
              },
              body1: {
                lineHeight: 1.25,
              },
            },
          }}
        >
          {config.map(line => (
            <Typography
              component={line.variant === 'h1' ? (isEdit ? 'h2' : 'h1') : 'p'}
              variant={line.variant}
              color={line.paletteColor}
              mb={0.25}
              whiteSpace='pre-line'
              className={line.className}
              key={line.text}
            >
              {line.text}
            </Typography>
          ))}
        </ThemeOverride>
      </Wrapper>
    </Box>
  );
}

const Wrapper = styled(Box)({
  padding: '.25rem 0',
});

const DashedVerticalLine = styled(Box)(({ theme }) => ({
  borderLeft: '2px dashed',
  borderLeftColor: theme.palette.text.secondary,
  marginRight: '1rem',
}));
